import { Link } from 'react-router-dom';

export default function CTAFeature() {
  return (
    <section className="flex flex-col lg:flex-row">
      <div className="lg:w-1/2 bg-background-100 relative overflow-hidden min-h-[400px] lg:min-h-[520px]">
        <img
          src="https://readdy.ai/api/search-image?query=Mobile%20phone%20displaying%20Korean%20manga%20reading%20app%20interface%20elegant%20modern%20UI%20design%20with%20manga%20content%20visible%20clean%20minimal%20style%20warm%20cream%20tones%20soft%20lighting&width=960&height=800&seq=cta-app-mockup&orientation=portrait"
          alt="韩漫App阅读界面"
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute top-8 left-8">
          <span className="text-xs text-foreground-500 font-medium tracking-wider whitespace-nowrap">
            随时随地
          </span>
        </div>
        <div className="absolute bottom-8 left-8 right-8">
          <h2 className="font-heading text-4xl md:text-5xl font-black text-foreground-950 leading-tight">
            下拉式<br />阅读体验<br />全新升级
          </h2>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-50 flex items-center justify-center px-8 md:px-16 py-16 lg:py-0">
        <div className="max-w-md text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight mb-6">
            韩漫在线观看<br />免费下拉式阅读
          </h2>
          <p className="text-foreground-500 leading-relaxed mb-8 text-sm md:text-base">
            韩国漫画网为您提供最流畅的漫画免费下拉式阅读体验。无需繁琐的翻页操作，只需向下滑动即可畅览好看的韩国漫画全集。无论您喜欢恋爱、奇幻还是动作类型，在这里都能找到心仪的韩漫作品，享受完整阅读的乐趣。
          </p>
          <Link
            to="/category/love"
            className="inline-flex items-center gap-2 bg-primary-500 text-white px-8 py-3.5 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            立即体验
            <i className="ri-arrow-right-line text-lg w-5 h-5 flex items-center justify-center" />
          </Link>
        </div>
      </div>
    </section>
  );
}